module.exports = __webpack_public_path__ + "img/ASS.59be4ff8.jpg";